/**
 * Action constants for Spreadsheet module Redux actions
 */
export const SpreadsheetFormatActions = {
    // Store format data by spreadsheet ID
    STORE_FORMAT_DATA: 'STORE_FORMAT_DATA',
    // Clear format data for a specific spreadsheet ID
    CLEAR_FORMAT_DATA: 'CLEAR_FORMAT_DATA',
    // Clear all format data
    CLEAR_ALL_FORMAT_DATA: 'CLEAR_ALL_FORMAT_DATA',
    // Update format data for a specific spreadsheet ID
    UPDATE_FORMAT_DATA: 'UPDATE_FORMAT_DATA',
    // Store folder data by spreadsheet ID
    STORE_FOLDER_DATA: 'STORE_FOLDER_DATA',
    // Store filter data by spreadsheet ID
    STORE_FILTER_DATA: 'STORE_FILTER_DATA',
    // Update folder data for a specific spreadsheet ID
    UPDATE_FOLDER_DATA: 'UPDATE_FOLDER_DATA',
    // Update filter data for a specific spreadsheet ID
    UPDATE_FILTER_DATA: 'UPDATE_FILTER_DATA',
};

